import { crmPostCall } from '../../axios';
import { helpCenterApi } from '../../../utils/functions/helpCenterApis';
import { DOCUMENTSUPLOADURL, SERVERERROR } from '../constants';

export const documentsUploadUrl = helpCenterApi(DOCUMENTSUPLOADURL);
const documentsUpload = (state, body) => {
  const url = documentsUploadUrl;
  if (url) {
    return crmPostCall(state, url, body);
  }
  return Promise.reject(new Error(SERVERERROR));
};

export default { documentsUpload };
